'use es6';

let _ = t => t,
    _t;

import { GYPSUM } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import breakpoints from '../../utils/responsiveBreakpoints';
const UnavailableProductLevelButton = styled.div.withConfig({
  displayName: "UnavailableProductLevelButton",
  componentId: "sc-1jq21gm-0"
})(["width:calc(100% / 3);background-color:", ";font-size:14px;", ""], GYPSUM, breakpoints.phone(_t || (_t = _`
    display: none;
  `)));
export default UnavailableProductLevelButton;